import { Button } from "@/atoms-react/button/Button.react";
import { Base } from "@/atoms-react/text/Text.react";
import { Themes } from "@/types/theme";
import _ from "lodash";
import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";

type IdentityDocumentsProps = React.ComponentPropsWithoutRef<"div">;

export const LevelSupport = ({ ...props }: IdentityDocumentsProps) => {
  const { t } = useTranslation(["pass"]);

  const navigate = useNavigate();

  return (
    <div
      className={twMerge("flex flex-col justify-between", props.className)}
      {..._.omit(props, "className")}
    >
      <Base className="flex flex-row justify-center font-semibold text-base">
        {t("olkypass.mainPage.navigation_account_menu.link.support")}
      </Base>

      <Base className="mt-3 flex flex-row justify-center text-slate-800 text-sm">
        {t("olkypass.mainPage.support_description")}
      </Base>
      <div className="flex flex-row justify-center">
        <Button
          theme={Themes.white}
          className="mt-5 w-2/6 border-primary text-sm 2xl:w-full"
          onClick={() => {
            navigate("/pass/support");
          }}
          size="md"
        >
          {t("olkypass.general.level_modal_documents.gold_form_button")}
        </Button>
      </div>
    </div>
  );
};
